module.exports = __webpack_public_path__ + "img/弹幕.e6b04c8d.png";